<div class="container-fluid contentHeight">
    <div class="admLicenseCtn">
        <h1 class="text-center containerTitle">Gestion des licences</h1>
        <nav>
            <div class="nav nav-tabs  bg-light" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-profile-tab" data-toggle="tab" role="tab" aria-controls="nav-profile" aria-selected="false" (click)="toggleTab('2', 'nav-profile','nav-profile-tab')">Codes absents/Mails en attente</a>
                <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" role="tab" aria-controls="nav-contact" aria-selected="false" (click)="toggleTab('3', 'nav-contact','nav-contact-tab')">Paiements en attente</a>
                <a class="nav-item nav-link" id="nav-stat4-tab" data-toggle="tab" role="tab" aria-controls="nav-stat4" aria-selected="false" (click)="toggleTab('4', 'nav-stat4','nav-stat4-tab')">Virements bancaires/Chèques</a>
                <a class="nav-item nav-link" id="nav-stat5-tab" data-toggle="tab" role="tab" aria-controls="nav-stat5" aria-selected="false" (click)="toggleTab('5', 'nav-stat5','nav-stat5-tab')">Dossiers complétés</a>
            </div>
        </nav>
        <div class="tab-content adminContent flex flex-column flex-grow-1" id="nav-tabContent">
            <div class="row bg-light noMargin">
                <div class="col-6">
                    <mat-form-field class="ml-2">
                        <mat-label>Rechercher</mat-label>
                        <input id="adminLicenceLacourSearch" matInput [value]="valSearch" (change)='valSearch=$event.target.value' (keyup)="applyFilter($event.target.value)">
                    </mat-form-field>
                    <mat-checkbox [checked]="conserverRecherche" (change)="changeFlagConserverRecherche()">Conserver recherche</mat-checkbox>
                </div>
                <div class="col-6">
                    <div class="text-right"> <i aria-hidden="true" (click)="refreshTab()" class="fas fa-sync  fa-1-2x p-2 pointer steelblue"></i> </div>
                </div>
            </div>
            <!-- STATUS 1 -->
            <div class="tab-pane noOverflow fade show active position-relative flex-grow-1" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="activationSource" (matSortChange)="sortScale($event,'1')">
                    <!--matSortActive="invoiceDate" matSortDirection="asc">-->
					<!-- Champs Affectation -->
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef>Affectation</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <div *ngIf="res.activationStatus == 1 || res.activationStatus == 7" matTooltip="Les codes n'ont pas été saisis ">
                                <i aria-hidden="true" class="fad fa-clipboard-user fa-1-2x twoToneRed nopointer"></i>
                            </div>
                            <div *ngIf="res.activationStatus == 2 || res.activationStatus == 8" matTooltip="Le mail n'a pas été envoyé">
                                <i aria-hidden="true" class="fad fa-clipboard-user fa-1-2x nopointer"></i>
                            </div>
                            <div *ngIf="res.activationStatus == 3" matTooltip="En attente de paiement">
                                <i aria-hidden="true" class="fad fa-clipboard-user fa-1-2x twoToneBlue nopointer"></i>
                            </div>
                            <div *ngIf="res.activationStatus == 4" matTooltip="Le virement n'a pas été effectué ">
                                <i aria-hidden="true" class="fad fa-clipboard-user fa-1-2x twoToneLightBlue nopointer"></i>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Mouvement -->
                    <ng-container matColumnDef="mouvement">
                        <mat-header-cell *matHeaderCellDef> Mouvement </mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <div *ngIf="res.activationStatus == 5">
                                <div *ngIf="res.isChecked == 0">
                                    <input type="checkbox" id="res.activationID"
                                           (change)="onIsCheckedChange(res.activationID)">
                                </div>
                                <div *ngIf="res.isChecked == 1">
                                    <input type="checkbox" checked="checked" id="res.activationID"
                                           (change)="onIsCheckedChange(res.activationID)">
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Numéro de dossier -->
                    <ng-container matColumnDef="activationID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>N° dossier</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.activationID}}</mat-cell>
                    </ng-container>
                    <!-- Champs Numéro de balance -->
                    <ng-container matColumnDef="scaleCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>N° de balance</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.scaleCode}}</mat-cell>
                    </ng-container>
                    <!-- Champs Date d'activation -->
                    <ng-container matColumnDef="activationDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date d'activation</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.activationDate | date:'dd/MM/yyyy'}}</mat-cell>
                    </ng-container>
                    <!-- Champs Date de commande -->
                    <ng-container matColumnDef="transDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date de commande</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.transDate | date:'dd/MM/yyyy'}}</mat-cell>
                    </ng-container>
                    <!-- Champs Date de paiement-->
                    <ng-container matColumnDef="invoiceDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date de paiement</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.invoiceDate  | date:'dd/MM/yyyy'}}</mat-cell>
                    </ng-container>
                    <!-- Champs Identité ctc -->
                    <ng-container matColumnDef="ctcName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Identité ctc</mat-header-cell>
                        <mat-cell *matCellDef="let res"> <span (click)="changeCtc($event , res.ctcLogin , res.activationID)"> {{res.ctcFirstName}} {{res.ctcName}} </span></mat-cell>
                    </ng-container>
                    <!-- Champs Utilisateur -->
                    <ng-container matColumnDef="userLoginUnisite">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Utilisateur</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.userLoginUnisite}}</mat-cell>
                    </ng-container>
                    <!-- Champs Nom utilisateur -->
                    <ng-container matColumnDef="userName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Utilisateur</mat-header-cell>
                        <mat-cell *matCellDef="let res" matTooltip="{{res.userLoginUnisite}}"> {{res.userName}} {{res.userFirstName}} </mat-cell>
                    </ng-container>
                    <!-- Champs Compagnie utilisateur -->
                    <ng-container matColumnDef="companyUnisiteCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Compagnie utilisateur</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.companyUnisiteCode}}</mat-cell>
                    </ng-container>
                    <!-- Champs  Payeur -->
                    <ng-container matColumnDef="payorLoginUnisite">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Payeur</mat-header-cell>
                        <mat-cell *matCellDef="let res" matTooltip="{{res.payorLoginUnisite}}">{{res.payorName}} {{res.payorFirstName}}</mat-cell>
                    </ng-container>
                    <!-- Champs Compagnie Payeur -->
                    <ng-container matColumnDef="companyPayorUnisiteCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Compagnie payeur</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.companyPayorUnisiteCode}}</mat-cell>
                    </ng-container>
                    <!-- Champs Editer -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef>Editer</mat-header-cell>
                        <mat-cell *matCellDef="let res" (click)="displayInfoActivation(res.activationID, '1', res.billingID)" class="pointer">
                            <i aria-hidden="true" [ngClass]="(res.activationStatus == 2 || res.activationStatus == 8) ? 'fas fa-user-check fa-1-2x' : 'fas fa-user-edit fa-1-2x'"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Mail -->
                    <ng-container matColumnDef="mail">
                        <mat-header-cell *matHeaderCellDef>Mail</mat-header-cell>
                        <mat-cell *matCellDef="let res" class="pointer">
                            <span (click)="displayMailInfo(res.activationID)">
                                <i aria-hidden="true" class="fad fa-paper-plane fa-1-2x twoToneBlue"></i>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Code SAGE -->
                    <ng-container matColumnDef="sageCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code SAGE </mat-header-cell>
                        <mat-cell *matCellDef="let res" class=""> {{res.sageCode}} </mat-cell>
                    </ng-container>
                    <!-- Champs Numéro de facture -->
                    <ng-container matColumnDef="facture">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Numéro de facture</mat-header-cell>
                        <mat-cell *matCellDef="let res" class="">
                            <span *ngIf="!res.invoiceCode" (click)="displayInvoiceModal(res.activationID,res.billingID)">
                                <i aria-hidden="true" class="fad fa-file-invoice fa-1-2x twoToneRed nopointer"></i>
                            </span>
                            <span *ngIf="res.invoiceCode"> {{res.invoiceCode}} </span>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Editer -->
                    <ng-container matColumnDef="finalEdit">
                        <mat-header-cell *matHeaderCellDef>Editer</mat-header-cell>
                        <mat-cell *matCellDef="let res" class="pointer" (click)="displayInfoActivation(res.activationID, '2', res.billingID)">
                            <i aria-hidden="true" class="fad fa-edit  fa-1-2x twoToneBlue"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Raison Sociale Payeur -->
                    <ng-container matColumnDef="payorSocialReason">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Raison Sociale Payeur</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.companyPayorSocialReason}}</mat-cell>
                    </ng-container>
                    <!-- Champs En attente de paiement -->
                    <ng-container matColumnDef="waitPayment">
                        <mat-header-cell *matHeaderCellDef>En attente de paiement</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <span class="fa-1-2x paymentWaiting ">
                                <i aria-hidden="true" class="far fa-money-bill-alt fa-1-2x steelblue nopointer"></i>
                                <i aria-hidden="true" class="fad fa-clock fa-xs text-danger nopointer"></i>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Accepter le virement -->
                    <ng-container matColumnDef="paymentInfo">
                        <mat-header-cell *matHeaderCellDef>Accepter le virement</mat-header-cell>
                        <mat-cell *matCellDef="let res" (click)="displayPayementInfo(res.billingID)" class="pointer">
                            <i aria-hidden="true" class="far fa-badge-check fa-1-2x"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Code d'activation balance -->
                    <ng-container matColumnDef="activationCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code d'activation balance</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.activationCode}}</mat-cell>
                    </ng-container>
                    <!-- Champs Endormir l'activation -->
                    <ng-container matColumnDef="sleepy">
                        <mat-header-cell *matHeaderCellDef>Cacher la demande</mat-header-cell>
                        <mat-cell *matCellDef="let res"> <i aria-hidden="true" class="far  fa-eye-slash  fa-1-2x pointer" (click)="sleepyModal(res.activationID);" style="color:gray"></i></mat-cell>
                    </ng-container>

                    <!-- Champs afficher détail supplémentaire -->
                    <ng-container matColumnDef="detailRow">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let res"> <i aria-hidden="true" class="fad fa-file-invoice fa-1-2x pointer twoToneBlue" (click)="detailRow(res.activationID);"></i></mat-cell>
                    </ng-container>

                    <!-- Champs suppression facturation / activation -->
                    <!--<ng-container matColumnDef="delete">
                      <mat-header-cell *matHeaderCellDef></mat-header-cell>
                      <mat-cell *matCellDef="let res"> <i aria-hidden="true" class="fad fa-trash-alt fa-1-2x pointer twoToneRed" (click)="deleteRow(res.activationID, res.billingID);"></i></mat-cell>
                    </ng-container>-->

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</div>

<!-- Modal - Statut 1 ou 7 codes unisites -->
<div id="unisiteModal" class="modal">
    <div class="modal-content">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('unisiteModal');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h1>Informations Client</h1>
        </div>
        <div *ngFor="let info of dataInfo">
            <div class="row mx-auto">
                <div class="col-6">
                    <hr>
                    <h3> <i aria-hidden="true" class="fad fa-balance-scale-right fa-1-2x twoToneGreen"></i> Balance</h3>
                    <div class="row">
                        <div class="col-6"> <span class="font-weight-bold"> Numéro de balance : </span> {{ info.scaleCode }} </div>
                        <div class="col-6"> <span class="font-weight-bold"> Numéro de série de la balance : </span> {{ info.serialNumber }} </div>
                        <div class="col-12" *ngIf="status == '5'"> <span class="font-weight-bold"> Code d'activation : </span> {{ info.activationCode }} </div>
                        <div class="col-12" *ngIf="status == '5'"> <span class="font-weight-bold"> Date d'activation : </span> {{ info.licenceStart | date:'dd/MM/yyyy' }} </div>
                        <div class="col-12" *ngIf="status == '5'"> <span class="font-weight-bold"> Date d'expiration : </span> {{ info.licenceEnd | date:'dd/MM/yyyy' }} </div>
                    </div>
                </div>
                <div class="col-6">
                    <hr>
                    <h3>   <i aria-hidden="true" class="fad fa-user-hard-hat fa-1-2x twoToneLightGreen"></i> Ctc</h3>
                    <div class="row">
                        <div class="col-6">  <span class="font-weight-bold"> Nom/Prénom : </span>  {{ info.ctcfirstname }} {{ info.ctcname }} </div>
                        <div class="col-6"> <span class="font-weight-bold"> Adresse mail :  </span>  {{ info.ctcmail }} </div>
                        <div class="col-6"> <span class="font-weight-bold"> Langue :  </span>  {{ info.ctclanguage }} </div>
                        <div class="col-6"> <span class="font-weight-bold"> Login Unisite :  </span>  {{ info.ctclogin }} </div>
                    </div>
                </div>
                <!-- SI UTILISATEUR = PAYEUR -->
                <div *ngIf="info.username == info.payorname && info.userfirstname == info.payorfirstname ; else elseNotSame" class="col-6">
                    <hr>
                    <h3>  <i aria-hidden="true" class="fad fa-hand-receiving twoToneBlue"></i> Utilisateur </h3>
                    <div class="row">
                        <div class="col-6"> <span class="font-weight-bold">Nom : </span> {{ info.username }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Prénom :</span> {{ info.userfirstname }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Téléphone Principal : </span>  {{ info.userphone }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Adresse mail : </span> {{ info.usermail }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Téléphone Mobile :</span> {{ info.usermobile }}</div>
                        <form [formGroup]="unisiteUser" class="col-6" *ngIf="info.activStatut == 1 || info.activStatut == 2">
                            <label for="unisite" class="font-weight-bold"> Login Unisite :</label>
                            <div *ngIf="editUnisite == true"> <input type="text" class="ml-2" formControlName="loginUnisiteUser"> </div>
                            <span *ngIf="editUnisite == false" class="col-6">  {{info.userloginunisite}} </span>
                        </form>
                    </div>
                </div>
                <div *ngIf="info.username == info.payorname && info.userfirstname == info.payorfirstname" class="col-6">
                    <hr>
                    <h3>  <i aria-hidden="true" class="fad fa-industry-alt twoToneBlue"></i> Compagnie Utilisateur </h3>
                    <div class="row">
                        <div class="col-6"> <span class="font-weight-bold"> Raison sociale :  </span> {{ info.companysocialreason }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Adresse :  </span> {{ info.companyaddress }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Code postal : </span>  {{ info.companypostalcode }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Ville :</span>  {{ info.companycity }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Pays : </span>  {{ info.companycountry }}</div>
                        <div class="col-6"> <span class="font-weight-bold">Siret : </span> {{ info.companyPayorsiret }}</div>
                        <div class="col-6"> <span class="font-weight-bold">n° TVA intracommunautaire : </span> {{ info.companyPayortva }}</div>
                        <form [formGroup]="unisiteCompany" class="col-6">
                            <label for="unisite" class="font-weight-bold"> Code Unisite :</label>
                            <input *ngIf="editUnisite == true" type="text" class="ml-2" formControlName="loginUnisiteUserCompany">
                            <span *ngIf="editUnisite == false" class="col-6"> {{info.companyunisitecode}} </span>
                        </form>
                    </div>
                </div>
                <ng-template #elseNotSame>
                    <div class="col-6">
                        <hr>
                        <h3>  <i aria-hidden="true" class="fad fa-hand-receiving twoToneBlue"></i> Utilisateur </h3>
                        <div class="row">
                            <div class="col-6"> <span class="font-weight-bold">Nom : </span> {{ info.username }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Prénom :</span> {{ info.userfirstname }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Téléphone Principal : </span>  {{ info.userphone }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Adresse mail : </span> {{ info.usermail }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Téléphone Mobile :</span> {{ info.usermobile }}</div>
                            <form [formGroup]="unisiteUser" class="col-6" *ngIf="info.activStatut == 1 || info.activStatut == 2">
                                <label for="unisite" class="font-weight-bold"> Login Unisite :</label>
                                <div *ngIf="editUnisite == true"> <input type="text" class="ml-2" formControlName="loginUnisiteUser"> </div>
                                <span *ngIf="editUnisite == false" class="col-6">  {{info.userloginunisite}} </span>
                            </form>
                        </div>
                    </div>
                    <div class="col-6">
                        <hr>
                        <h3>  <i aria-hidden="true" class="fad fa-hand-holding-usd twoToneLightBlue"></i> Payeur</h3>
                        <div class="row">
                            <div class="col-6"> <span class="font-weight-bold">Nom : </span> {{ info.payorname }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Prénom :</span> {{ info.payorfirstname }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Adresse mail : </span> {{ info.payormail }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Téléphone Principal : </span> {{ info.payorphone }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Téléphone Mobile :</span> {{ info.payormobile }}</div>
                            <form [formGroup]="unisitePayor" class="col-6" *ngIf="info.activStatut == 1 || info.activStatut == 2">
                                <label for="unisite" class="font-weight-bold"> Login Unisite :</label>
                                <input *ngIf="editUnisite == true" type="text" class="ml-2" formControlName="loginUnisitePayor">
                                <span *ngIf="editUnisite == false" class="col-6"> {{info.payorloginunisite}} </span>
                            </form>
                        </div>
                    </div>
                    <div class="col-6">
                        <hr>
                        <h3>  <i aria-hidden="true" class="fad fa-industry-alt twoToneBlue"></i> Compagnie Utilisateur</h3>
                        <div class="row">
                            <div class="col-6"> <span class="font-weight-bold"> Raison sociale :  </span> {{ info.companysocialreason }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Adresse :  </span> {{ info.companyaddress }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Code postal : </span>  {{ info.companypostalcode }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Ville :</span>  {{ info.companycity }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Pays : </span>  {{ info.companycountry }}</div>
                            <form [formGroup]="unisiteCompany" class="col-6">
                                <label for="unisite" class="font-weight-bold"> Code Unisite :</label>
                                <input *ngIf="editUnisite == true" type="text" class="ml-2" formControlName="loginUnisiteUserCompany">
                                <span *ngIf="editUnisite == false" class="col-6"> {{info.companyunisitecode}} </span>
                            </form>
                        </div>
                    </div>
                    <div class="col-6">
                        <hr>
                        <h3>  <i aria-hidden="true" class="fad fa-industry-alt twoToneLightBlue"></i> Compagnie Payeur </h3>
                        <div class="row">
                            <div class="col-6"> <span class="font-weight-bold"> Raison sociale :  </span> {{ info.companyPayorsocialreason }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Adresse :  </span> {{ info.companyPayoraddress }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Code postal : </span> {{ info.companyPayorpostalcode }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Ville :</span> {{ info.companyPayorcity }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Pays : </span> {{ info.companyPayorcountry }}</div>
                            <div class="col-6"> <span class="font-weight-bold">Siret : </span> {{ info.companyPayorsiret }}</div>
                            <!--<div class="col-6"> <span class="font-weight-bold"> Tva : </span> { info.companyPayortva }</div>-->
                            <div class="col-6"> <span class="font-weight-bold">n° TVA intracommunautaire : </span> {{ info.companyPayortva }}</div>
                            <form [formGroup]="unisiteCompanyPayor" class="col-6">
                                <label for="unisite" class="font-weight-bold"> Code Unisite :</label>
                                <input *ngIf="editUnisite == true" type="text" class="ml-2" formControlName="loginUnisiteUserCompanyPayor">
                                <span *ngIf="editUnisite == false" class="col-6"> {{info.companyPayorunisitecode}} </span>
                            </form>
                        </div>
                    </div>
                </ng-template>
                <hr class="col-11 mx-auto">
                <div class="col-4">
                    <h3>   <i aria-hidden="true" class="fad fa-file-alt fa-1-2x twoToneRedOrange"></i> Code SAGE </h3>
                    <form [formGroup]="sageForm" class="col-6">
                        <label for="unisite" class="font-weight-bold"> <span class="font-weight-bold"> Code SAGE : </span> </label>
                        <input type="text" class="ml-2" formControlName="sageCode">
                    </form>
                </div>
                <div *ngIf="editInvoice == true " class="col-4">
                    <h3>   <i aria-hidden="true" class="fad fa-file-alt fa-1-2x twoToneGreen"></i> Numéro de facture </h3>
                    <form [formGroup]="invoiceForm" class="col-6">
                        <label for="unisite" class="font-weight-bold"> <span class="font-weight-bold"> Numéro de facture : </span> </label>
                        <input type="text" class="ml-2" formControlName="invoiceCode">
                    </form>
                </div>

                <div class="col-4">
                    <!--<h3><i aria-hidden="true" class="fad fa-file-alt fa-1-2x twoToneGreen"></i> </h3>-->
                    <button class="btn btn-primary mr-2" (click)="sendCodeActivationLicence(info.billingID, info.activationId)"> Renvoyer code d'activation licence </button>
                </div>

                <div *ngIf="unisiteError" class="col-12 text-danger text-center">
                    <p> Veuillez remplir les champs suivants: </p>
                    <ul>
                        <li *ngIf="unisiteLoginError"> Login Unisite </li>
                        <li *ngIf="unisiteCodeError"> Code Unisite </li>
                        <li *ngIf="sageError"> Code SAGE </li>
                    </ul>
                </div>
                <div class="text-center col-12">
                    <button *ngIf="editInvoice == true" class="btn btn-success" (click)="sendInvoiceCode(info.billingID)"> Enregistrer </button>
                    <button *ngIf="editInvoice == false" class="btn btn-primary mr-2" (click)="sendUnisiteCode(true, null)"> Enregistrer </button>
                    <button *ngIf="editInvoice == false " class="btn btn-success mr-2 col-2" (click)="sendUnisiteCode(true, info.activationId)"> Valider et envoyer le mail  <i aria-hidden="true" class="fas fa-paper-plane ml-1"></i> </button>
                    <button *ngIf="editInvoice == false " class="btn btn-success col-2" (click)="sendUnisiteCode(true, info.activationId, true)"> Valider sans envoyer de mail  <span class="fa-stack ml-1"> <i aria-hidden="true" class="fa-thin fa-slash fa-stack-1x"></i> <i aria-hidden="true" class="fas fa-paper-plane fa-stack-1x"></i> </span></button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal - Statut 2 Mail -->
<div id="mailModal" class="modal">
    <div class="modal-content">
        <div class="row" *ngFor="let data of mailInfo">
            <div class="col-12">
                <span class="text-right pointer close" (click)="closeModal('mailModal');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1 class="text-center">  <i aria-hidden="true" class="fad fa-hand-receiving twoToneBlue"></i> {{ noMail ? 'Confirmation' : 'Login / Mot de passe utilisateur' }} </h1>
            </div>
            <div *ngIf="data.activStatut == 2" class="col-12">
                <div class="col-12">
                    <div class="row">
                        <div class="col-3 pl-2 pt-2 text-right"> {{ data.userloginunisite }} </div>
                        <form [formGroup]="passwordUser" class="col-3">
                            <input type="text" class="form-control" formControlName="passwordUser" placeholder="Saisir le mot de passe unisite du payeur">
                        </form>
                    </div>
                </div>
                <div class="col-12" *ngIf="data.payorloginunisite != data.userloginunisite">
                    <h1 class="text-center"> <i aria-hidden="true" class="fad fa-hand-holding-usd twoToneLightBlue"></i> Login / Mot de passe payeur </h1>
                    <div class="row">
                        <div class="col-3 pl-2 pt-2 text-right"> {{ data.payorloginunisite }} </div>
                        <form [formGroup]="passwordPayor" class="col-3">
                            <input type="text" class="form-control" formControlName="passwordPayor" placeholder="Saisir le mot de passe unisite du payeur">
                        </form>
                    </div>
                </div>
            </div>
            <div *ngIf="data.activStatut == 8" class="col-12 text-center">
                <ng-container *ngIf="!noMail">
                    <label>Un mail d'information sera envoyé à l'utilisateur suivant : {{data.usermail}}</label>
                    <div *ngIf="data.payorloginunisite != data.userloginunisite" class="text-center">
                        <label> ainsi qu'au payeur suivant : {{data.payormail}}</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="noMail">
                    <label>Confirmer la validation ?</label>
                </ng-container>
            </div>
            <div class="col-12">
                <div *ngIf="errorUserUnisite" class="text-danger"> Impossible d'envoyer les mails, un des code unisite utilisateur est faux </div>
                <div *ngIf="errorPayorUnisite" class="text-danger"> Impossible d'envoyer les mails, un des code unisite payeurs est faux </div>
                <div *ngIf="errorRightUnisite" class="text-danger"> L'utilisateur ou le payeur ne dispose pas des droits d'utilisation ixell</div>
                <div class="text-center">
                    <div *ngIf="errorMail==true" class="text-danger">Le compte utilisateur n'appartient pas à la société ou le mot de passe est incorrect</div>
                    <button *ngIf="!noMail" class="btn btn-secondary" (click)="sendMails(data)"> Envoyer </button>
                    <button *ngIf="noMail" class="btn btn-secondary" (click)="completeWithoutMail(data)"> Confirmer </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal - Statut 4  Paiement par virement bancaire/chèque -->
<div id="payementModal" class="modal">
    <div class="modal-content" *ngIf="order">
        <div class="row">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('payementModal');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1> Validation du paiement  </h1> <hr>
            </div>
            <div class="col-3 mx-auto">
                <h3>  <i aria-hidden="true" class="fad fa-industry-alt twoToneLightBlue"></i> Compagnie Payeur </h3>
                <div class="row">
                    <div class="col-12"> <span class="font-weight-bold"> Raison sociale :  </span> {{ order.socialReason }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Adresse :  </span> {{ order.address }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Ville :</span> {{ order.city }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Pays : </span> {{ order.country }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Code unisite : </span> {{ order.unisiteCode }}</div>
                </div>
            </div>
            <div class="col-3 mx-auto">
                <h3>  <i aria-hidden="true" class="fad fa-hand-holding-usd twoToneLightBlue"></i> Payeur</h3>
                <div class="row">
                    <div class="col-12"> <span class="font-weight-bold">Nom : </span> {{ order.name }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Prénom :</span> {{ order.firstname }}</div>
                </div>
            </div>
            <div class="col-6 mx-auto">
                <div class="col-10 mx-auto bg-light">
                    <h3 class="pt-2"> Commande </h3>
                    <table class="commande">
                        <caption></caption>
                        <thead>
                            <tr>
                                <th scope="col">
                                    Produit
                                </th>
                                <th scope="col">
                                    Prix Unitaire HT
                                </th>
                                <th scope="col">
                                    Quantité
                                </th>
                                <th scope="col">
                                    Montant Total HT
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let product of order.lstBillDetails">
                                <td>
                                    {{product.product.labelP}}
                                </td>
                                <td>
                                    {{product.product.amountP | number : '1.2-2'}}€
                                </td>
                                <td>
                                    {{product.qty}}
                                </td>
                                <td>
                                    {{product.product.amountP * product.qty | number : '1.2-2'}}€
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col-12 text-right">
                        <span class="font-weight-bold text-danger"> Total : </span> {{orderTotal | number : '1.2-2'}}€<br />
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-3">
                <span class="font-italic"> Si le paiement a été envoyé et validé, cliquez sur le bouton accepter ci-dessous </span>
            </div>
            <div class="col-12">
                <div class="mx-auto row-2 text-center">
                    <button class="btn btn-success btn-lg" (click)="validatePayement(order.activationID, order.billingID)"> Accepter </button>&nbsp;
                    <button class="btn btn-success btn-lg" (click)="validatePayement(order.activationID, order.billingID, true)"> Accepter sans envoi de mail </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal - Changement de ctc -->
<div id="ctcModal" class="modal">
    <div class="modal-content">
        <div class="row">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('ctcModal');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1> Réaffectation du dossier à un nouveau CTC </h1> <hr>
            </div>
            <div class="col-8 mx-auto" *ngFor="let info of dataInfo">
                <div class="row">
                    <div class="col-10 mx-auto">
                        <h3 class="text-center"> Informations du dossier </h3>
                    </div>
                    <hr class="col-7 mx-auto">
                    <div class="col-6">
                        <div>
                            <span class="font-weight-bold"> Ctc actuel : </span> <span> {{info.ctcfirstname}} {{info.ctcname}} </span>
                        </div>
                        <div>
                            <span class="font-weight-bold"> Login du ctc actuel : </span> <span> {{info.ctclogin}} </span>
                        </div>
                    </div>
                    <form [formGroup]="newCtc" class="col-6" (click)="resetCtcError()">
                        <div class="col-12">
                            <span class="font-weight-bold"> Login du nouveau ctc : </span>
                            <input type="text" class="form-control" formControlName="ctcLogin" placeholder="Login unisite du ctc">
                        </div>
                        <div class="col-12">
                            <span class="font-weight-bold"> Mot de passe du nouveau ctc : </span>
                            <input type="password" class="form-control" formControlName="ctcPassword" placeholder="Mot de passe unisite du ctc">
                        </div>
                        <mat-form-field class="col-12 mt-2">
                            <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                            <mat-select formControlName="ctcLanguage" required>
                                <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                            </mat-select>
                            <!-- <mat-error>Saisissez le pays de la société </mat-error> -->
                        </mat-form-field>
                    </form>
                </div>
            </div>
            <div class="col-12  text-center">
                <span *ngIf="errorCtcAccount" class="text-danger"> Le login mot de passe est incorrect ou le compte n'a pas le droit CTC </span>
                <span *ngIf="errorCtcInput" class="text-danger"> Veuillez remplir tout les champs demandés</span>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-success btn-lg" (click)="changeCtcDb()"> Envoyer </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal - Sleepy activation -->
<div id="sleepyModal" class="modal2">
    <div class="modal-content2">
        <div class="row">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('sleepyModal');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1> Souhaitez-vous cacher cette activation? </h1> <hr>
            </div>
            <div class="col-8 mx-auto h4">
                Suite à cela vous ne pourrez plus consulter cette activation, celle-ci ne sera pas totalement effacée mais sera considérée comme endormie.
            </div>
            <div class="col-12 text-center mt-5">
                <button class="btn btn-success btn-lg" (click)="setSleepyActivation()"> Accepter </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal - mail code activation -->
<div id="mailCodeActivation" class="modal2">
    <div class="modal-content2">
        <div class="row">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('mailCodeActivation');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1> Mail code activation </h1> <hr>
            </div>
            <div class="col-8 mx-auto h4">
                Un mail avec le code d'activation balance du client a été renvoyé.
            </div>
            <div class="col-12 text-center mt-5">
                <button class="btn btn-success btn-lg" (click)="closeModal('mailCodeActivation')"> Fermer </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal - detail row -->
<div id="detailRow" class="modal">
    <div class="modal-content">
        <div class="row">
            <div class="col-12 text-center">
                <span class="text-right pointer close" (click)="closeModal('detailRow');">
                    <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
                </span>
                <h1> Detail ligne : </h1> <hr>

            </div>
            <div *ngIf="scaleFull != null" class="col-12 mx-auto">

                <table class="table scaleFull">
                    <thead>
                        <tr>
                            <th>scale ID</th>
                            <th>serial number</th>
                            <th>code</th>
                            <th colspan="2">licence start &#11157; end</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{scaleFull.s_scaleID}}</td>
                            <td>{{scaleFull.s_serialNumber}}</td>
                            <td>{{scaleFull.s_code}}</td>
                            <td colspan="2">
                                <ng-container *ngIf="scaleFull.s_licenceStart?.length && scaleFull.s_licenceEnd?.length">
                                    {{scaleFull.s_licenceStart}} &#11157; {{scaleFull.s_licenceEnd}}
                                    <span class="pointer steelblue" (click)="deleteScaleLicenceDates(scaleFull.s_scaleID)" title="Effacer"><i class="fas fa-trash-alt"></i></span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table *ngFor="let activation of scaleFull.activationFull; index as actI" class="table activationFull">
                    <thead>
                        <tr class="thead-activation">
                            <th>activation ID</th>
                            <th>code activation</th>
                            <th>decode licence start</th>
                            <th>decode licence end</th>
                            <th>decode durée</th>
                            <th>activation date</th>
                            <th>status</th>
                            <th>sleepy date</th>
                            <th>invoice date</th>
                            <th>date recovery</th>
                            <th>recovery notifications</th>
                            <th>sage code</th>
                            <th>invoice code</th>
                            <th>is checked</th>
                            <th>invoice notification</th>
                            <th>scale ID</th>
                            <th>user ID</th>
                            <th>user company ID</th>
                            <th>user colorUser ID</th>
                            <th>payor user ID</th>
                            <th>payor companyID</th>
                            <th>payor colorUser ID</th>
                            <th>ctc ID</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tbody-activation activation-{{activation.a_activationID}} {{activation.a_status == 19 ? 'deleted-opacity' : ''}}">
                            <td>{{activation.a_activationID}}</td>
                            <td>{{activation.a_activationCode}}</td>
                            <td>{{activation.decode_codeAtivationStart}}</td>
                            <td>{{activation.decode_codeAtivationEnd}}</td>
                            <td>{{activation.decode_codeAtivationDuree}}</td>
                            <td>{{activation.a_activationDate}}</td>
                            <td>{{StatusType[activation.a_status] }} ({{activation.a_status}})</td>
                            <td>{{activation.a_sleepyDate}}</td>
                            <td>{{activation.a_invoiceDate}}</td>
                            <td>{{activation.a_recoveryDate}}</td>
                            <td>{{activation.a_recoveryNotifications}}</td>
                            <td>{{activation.a_sageCode}}</td>
                            <td>{{activation.a_invoiceCode}}</td>
                            <td>{{YesNo[activation.a_isChecked]}} ({{activation.a_isChecked}})</td>
                            <td>{{activation.a_invoiceNotification}}</td>
                            <td>{{activation.a_scale_scaleID}}</td>
                            <td>{{activation.a_user_userid}}</td>
                            <td>{{activation.a_user_companyID}}</td>
                            <td>{{activation.a_user_colorUserID}}</td>
                            <td>{{activation.a_payor_userID}}</td>
                            <td>{{activation.a_payor_companyID}}</td>
                            <td>{{activation.a_payor_colorUserID}}</td>
                            <td>
                                <ng-container *ngIf="activation.a_ctc__edit === undefined">
                                    {{activation.a_ctc}}   -   {{activation.a_statusFullBillingDelete}}
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer steelblue" (click)="editActivationCTC(actI)" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                        <span class="pointer steelblue" (click)="rewindActivationCTC(actI)" *ngIf="activation.a_ctc !== oldScaleFull.activationFull[actI].a_ctc" title="Rétablir"><i class="fas fa-history"></i></span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="activation.a_ctc__edit !== undefined">
                                    <mat-form-field>
                                        <mat-label>CTC</mat-label>
                                        <mat-select [(ngModel)]="activation.a_ctc__edit">
                                            <mat-option *ngFor="let opt of activation.a_ctc__options" [value]="opt.idCtc">{{opt.firstname}} {{opt.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer primaryGreen" (click)="validateActivationCTC(actI)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                        <span class="pointer primaryRed" (click)="cancelActivationCTC(actI)" title="Annuler"><i class="fas fa-times"></i></span>
                                    </span>
                                </ng-container>
                            </td>
                            <td><i *ngIf="activation.a_status != 19 && activation.a_status != 5 && activation.a_statusFullBillingDelete == 1" aria-hidden="true" class="fad fa-trash-alt fa-1-2x pointer twoToneRed" (click)="deleteRowActivation(activation.a_activationID);"></i></td>
                        </tr>
                        <tr class="tbody-activationBilling">
                            <td colspan="1">Billing</td>
                            <td colspan="22">
                                <table class="table billingFull">
                                    <thead>
                                        <tr class="thead-billing">
                                            <th>billing ID</th>
                                            <th>nb products</th>
                                            <th>total amount</th>
                                            <th>transaction date</th>
                                            <th>transaction status</th>
                                            <th>invoice date</th>
                                            <th>payment CB</th>
                                            <th>unisite code</th>
                                            <th>login</th>
                                            <th>email</th>
                                            <th>language</th>
                                            <th>invoice code</th>
                                            <th>order number</th>
                                            <th>sage code</th>
                                            <th>FDP Manuel</th>
                                            <th>sended</th>
                                            <th>billing info</th>
                                            <th>currency</th>
                                            <th>invoice notification</th>
                                            <th>transaction ID</th>
                                            <th>tva ID</th>
                                            <th>Adr. Liv. ID</th>
                                            <th>Adr. Fact. ID</th>
                                            <th>billing detail ID</th>
                                            <th>product ID</th>
                                            <th>qty</th>
                                            <th>renting ID</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let billing of activation.billingFull" class="tbody-billing activation-{{activation.a_activationID}} billing-{{billing.b_billingID}} {{(activation.a_status == 19 || billing.b_transStatus == 19) ? 'deleted-opacity' : ''}}">
                                            <td>{{billing.b_billingID}}</td>
                                            <td>{{billing.b_nbProducts}}</td>
                                            <td>{{billing.b_amountTotal}}</td>
                                            <td>{{billing.b_transDate}}</td>
                                            <td>{{StatusBillingType[billing.b_transStatus]}} ({{billing.b_transStatus}})</td>
                                            <td>{{billing.b_InvoiceDate}}</td>
                                            <td>{{YesNo[billing.b_PaymentCB]}} ({{billing.b_PaymentCB}})</td>
                                            <td>{{billing.b_unisiteCode}}</td>
                                            <td>{{billing.b_login}}</td>
                                            <td>{{billing.b_email}}</td>
                                            <td>{{billing.b_language}}</td>
                                            <td>{{billing.b_invoiceCode}}</td>
                                            <td>{{billing.b_orderNumber}}</td>
                                            <td>{{billing.b_SageCode }}</td>
                                            <td>{{billing.b_FDPManuel}}</td>
                                            <td>{{YesNo[billing.b_isSended]}} ({{billing.b_isSended}})</td>
                                            <td>{{billing.b_billingInfo}}</td>
                                            <td>{{billing.b_currency}}</td>
                                            <td>{{billing.b_InvoiceNotification}}</td>
                                            <td>{{billing.b_transID}}</td>
                                            <td>{{billing.t_tva}}</td>
                                            <td>{{billing.b_idAdrLiv}}</td>
                                            <td>{{billing.b_idAdrFact}}</td>
                                            <td>{{billing.bd_billingdetailID}}</td>
                                            <td>{{ProductType[billing.p_typeP]}} ({{billing.p_typeP}})</td>
                                            <td>{{billing.bd_qty}}</td>
                                            <td>{{billing.bd_rentingID}}</td>
                                            <td><i *ngIf="billing.b_transStatus != 19 && billing.b_transStatus != 2" aria-hidden="true" class="fad fa-trash-alt fa-1-2x pointer twoToneRed" (click)="deleteRowBilling(billing.b_billingID, activation.a_activationID);"></i></td>
                                        </tr>
                                        <tr class="tbody-billing" *ngIf="actualtab !== 'nav-profile-tab'">
                                            <td colspan="28" class="text-center primaryGreen pointer" (click)="addBilling(activation.a_activationID)" title="Ajouter"> <i class="fas fa-plus"></i> </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr class="tbody-activationUser">
                            <td colspan="1">User</td>
                            <td colspan="22">
                                <ng-container *ngIf="activation.userFull.u_userid__edit === undefined">
                                    <table class="table userFull">
                                        <thead>
                                            <tr class="thead-user">
                                                <th>user ID</th>
                                                <th>gender</th>
                                                <th>name</th>
                                                <th>firstname</th>
                                                <th>mail</th>
                                                <th>phone</th>
                                                <th>mobile</th>
                                                <th>login unisite</th>
                                                <th>language</th>
                                                <th>unisite code</th>
                                                <th>company ID</th>
                                                <th>is ColorUser</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tbody-user">
                                                <td>
                                                    {{activation.userFull.u_userid}}
                                                    <span [style.whiteSpace]="'nowrap'">
                                                        <span class="pointer steelblue" (click)="editActivationUserFull(actI)" title="Échanger"><i class="fas fa-arrow-right-arrow-left"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="duplicateActivationUserFull(actI, false)" title="Dupliquer"><i class="fas fa-copy"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="rewindActivationUserFull(actI)" *ngIf="activation.userFull.u_userid !== oldScaleFull.activationFull[actI].userFull.u_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                    </span>
                                                </td>
                                                <td>{{activation.userFull.u_gender}}</td>
                                                <td>{{activation.userFull.u_name}}</td>
                                                <td>{{activation.userFull.u_firstname}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.userFull.u_mail__edit === undefined">
                                                        {{activation.userFull.u_mail}}
                                                        <span [style.whiteSpace]="'nowrap'" *ngIf="activation.userFull.duplicated">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'userFull', 'u_mail')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'userFull', 'u_mail', activation.userFull.u_userid)" *ngIf="activation.userFull.u_mail !== oldScaleFull.activationFull[actI].userFull.u_mail && activation.userFull.u_userid === oldScaleFull.activationFull[actI].userFull.u_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.userFull.u_mail__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.userFull.u_mail__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'userFull', 'u_mail', activation.userFull.u_userid)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'userFull', 'u_mail')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.userFull.u_phone}}</td>
                                                <td>{{activation.userFull.u_mobile}}</td>
                                                <td>{{activation.userFull.u_loginUnisite}}</td>
                                                <td>{{activation.userFull.u_language}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.userFull.u_unisiteCode__edit === undefined">
                                                        {{activation.userFull.u_unisiteCode}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'userFull', 'u_unisiteCode')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'userFull', 'u_unisiteCode', activation.userFull.u_userid)" *ngIf="activation.userFull.u_unisiteCode !== oldScaleFull.activationFull[actI].userFull.u_unisiteCode && activation.userFull.u_userid === oldScaleFull.activationFull[actI].userFull.u_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.userFull.u_unisiteCode__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.userFull.u_unisiteCode__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'userFull', 'u_unisiteCode', activation.userFull.u_userid)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'userFull', 'u_unisiteCode')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.userFull.u_company_companyID}}</td>
                                                <td>{{YesNo[activation.userFull.u_isColorUser]}} ({{activation.userFull.u_isColorUser}})</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                                <ng-container *ngIf="activation.userFull.u_userid__edit !== undefined">
                                    <mat-form-field style="width: 25em;">
                                        <mat-label>Utilisateur</mat-label>
                                        <input #input
                                               type="text"
                                               placeholder="Choisir..."
                                               matInput
                                               [(ngModel)]="activation.userFull.u_userid__edit"
                                               [ngModelOptions]="{updateOn: 'change'}"
                                               [matAutocomplete]="auto"
                                               (input)="filterActivationUserFullOptions(actI, false, input.value, input)"
                                               (focus)="filterActivationUserFullOptions(actI, false, input.value, input)"
                                               required>
                                        <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayActivationUserFullOption(actI, false)">
                                            <mat-option *ngFor="let opt of activation.userFull.u_userid__filteredOptions" [value]="opt.userID">{{opt.firstname}} {{opt.name}} ({{opt.userID}})</mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="!activation.userFull.u_userid__edit">
                                            Vous devez sélectionner un utilisateur pour pouvoir valider.
                                        </mat-error>
                                    </mat-form-field>
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer primaryGreen" (click)="validateActivationUserFull(actI)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                        <span class="pointer primaryRed" (click)="cancelActivationUserFull(actI)" title="Annuler"><i class="fas fa-times"></i></span>
                                    </span>
                                </ng-container>
                            </td>
                        </tr>

                        <tr class="tbody-activationPayor">
                            <td colspan="1">Payor</td>
                            <td colspan="22">
                                <ng-container *ngIf="activation.payorFull.p_userid__edit === undefined">
                                    <table class="table payorFull">
                                        <thead>
                                            <tr class="thead-payor">
                                                <th>user ID</th>
                                                <th>gender</th>
                                                <th>name</th>
                                                <th>firstname</th>
                                                <th>mail</th>
                                                <th>phone</th>
                                                <th>mobile</th>
                                                <th>login unisite</th>
                                                <th>language</th>
                                                <th>unisite code</th>
                                                <th>company ID</th>
                                                <th>is ColorUser</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tbody-payor">
                                                <td>
                                                    {{activation.payorFull.p_userid}}
                                                    <span [style.whiteSpace]="'nowrap'">
                                                        <span class="pointer steelblue" (click)="editActivationPayorFull(actI)" title="Échanger"><i class="fas fa-arrow-right-arrow-left"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="duplicateActivationUserFull(actI, true)" title="Dupliquer"><i class="fas fa-copy"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="rewindActivationPayorFull(actI)" *ngIf="activation.payorFull.p_userid !== oldScaleFull.activationFull[actI].payorFull.p_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                    </span>
                                                </td>
                                                <td>{{activation.payorFull.p_gender}}</td>
                                                <td>{{activation.payorFull.p_name}}</td>
                                                <td>{{activation.payorFull.p_firstname}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.payorFull.p_mail__edit === undefined">
                                                        {{activation.payorFull.p_mail}}
                                                        <span [style.whiteSpace]="'nowrap'" *ngIf="activation.payorFull.duplicated">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'payorFull', 'p_mail')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'payorFull', 'p_mail', activation.payorFull.p_userid)" *ngIf="activation.payorFull.p_mail !== oldScaleFull.activationFull[actI].payorFull.p_mail && activation.payorFull.p_userid === oldScaleFull.activationFull[actI].payorFull.p_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.payorFull.p_mail__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.payorFull.p_mail__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'payorFull', 'p_mail', activation.payorFull.p_userid)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'payorFull', 'p_mail')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.payorFull.p_phone}}</td>
                                                <td>{{activation.payorFull.p_mobile}}</td>
                                                <td>{{activation.payorFull.p_loginUnisite}}</td>
                                                <td>{{activation.payorFull.p_language}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.payorFull.p_unisiteCode__edit === undefined">
                                                        {{activation.payorFull.p_unisiteCode}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'payorFull', 'p_unisiteCode')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'payorFull', 'p_unisiteCode', activation.payorFull.p_userid)" *ngIf="activation.payorFull.p_unisiteCode !== oldScaleFull.activationFull[actI].payorFull.p_unisiteCode && activation.payorFull.p_userid === oldScaleFull.activationFull[actI].payorFull.p_userid" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.payorFull.p_unisiteCode__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.payorFull.p_unisiteCode__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'payorFull', 'p_unisiteCode', activation.payorFull.p_userid)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'payorFull', 'p_unisiteCode')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.payorFull.p_company_companyID}}</td>
                                                <td>{{YesNo[activation.payorFull.p_isColorUser]}} ({{activation.payorFull.p_isColorUser}})</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                                <ng-container *ngIf="activation.payorFull.p_userid__edit !== undefined">
                                    <mat-form-field style="width: 25em;">
                                        <mat-label>Utilisateur</mat-label>
                                        <input #input
                                               type="text"
                                               placeholder="Choisir..."
                                               matInput
                                               [(ngModel)]="activation.payorFull.p_userid__edit"
                                               [ngModelOptions]="{updateOn: 'change'}"
                                               [matAutocomplete]="auto"
                                               (input)="filterActivationUserFullOptions(actI, true, input.value)"
                                               (focus)="filterActivationUserFullOptions(actI, true, input.value)"
                                               required>
                                        <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayActivationUserFullOption(actI, true)">
                                            <mat-option *ngFor="let opt of activation.payorFull.p_userid__filteredOptions" [value]="opt.userID">{{opt.firstname}} {{opt.name}} ({{opt.userID}})</mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="!activation.payorFull.p_userid__edit">
                                            Vous devez sélectionner un utilisateur pour pouvoir valider.
                                        </mat-error>
                                    </mat-form-field>
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer primaryGreen" (click)="validateActivationPayorFull(actI)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                        <span class="pointer primaryRed" (click)="cancelActivationPayorFull(actI)" title="Annuler"><i class="fas fa-times"></i></span>
                                    </span>
                                </ng-container>
                            </td>
                        </tr>

                        <tr class="tbody-activationUserCompany">
                            <td colspan="1">Company</td>
                            <td colspan="22">
                                <ng-container *ngIf="activation.companyUserFull.c_companyID__edit === undefined">
                                    <table class="table userCompanyFull">
                                        <thead>
                                            <tr class="thead-userCompany">
                                                <th>company ID</th>
                                                <th>unisite code</th>
                                                <th>social reason</th>
                                                <th>address</th>
                                                <th>postal code</th>
                                                <th>city</th>
                                                <th>country</th>
                                                <th>siret</th>
                                                <th>tva</th>
                                                <th>siren</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tbody-userCompany">
                                                <td>
                                                    {{activation.companyUserFull.c_companyID}}
                                                    <span [style.whiteSpace]="'nowrap'">
                                                        <span class="pointer steelblue" (click)="editActivationCompanyUserFull(actI)" title="Échanger"><i class="fas fa-arrow-right-arrow-left"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="duplicateActivationCompanyUserFull(actI, false)" title="Dupliquer"><i class="fas fa-copy"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="rewindActivationCompanyUserFull(actI)" *ngIf="activation.companyUserFull.c_companyID !== oldScaleFull.activationFull[actI].companyUserFull.c_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyUserFull.c_unisiteCode__edit === undefined">
                                                        {{activation.companyUserFull.c_unisiteCode}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyUserFull', 'c_unisiteCode')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyUserFull', 'c_unisiteCode', activation.companyUserFull.c_companyID)" *ngIf="activation.companyUserFull.c_unisiteCode !== oldScaleFull.activationFull[actI].companyUserFull.c_unisiteCode && activation.companyUserFull.c_companyID === oldScaleFull.activationFull[actI].companyUserFull.c_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyUserFull.c_unisiteCode__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyUserFull.c_unisiteCode__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyUserFull', 'c_unisiteCode', activation.companyUserFull.c_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyUserFull', 'c_unisiteCode')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.companyUserFull.c_socialReason}}</td>
                                                <td>{{activation.companyUserFull.c_address}}</td>
                                                <td>{{activation.companyUserFull.c_postalCode}}</td>
                                                <td>{{activation.companyUserFull.c_city}}</td>
                                                <td>{{activation.companyUserFull.c_country}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyUserFull.c_siret__edit === undefined">
                                                        {{activation.companyUserFull.c_siret}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyUserFull', 'c_siret')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyUserFull', 'c_siret', activation.companyUserFull.c_companyID)" *ngIf="activation.companyUserFull.c_siret !== oldScaleFull.activationFull[actI].companyUserFull.c_siret && activation.companyUserFull.c_companyID === oldScaleFull.activationFull[actI].companyUserFull.c_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyUserFull.c_siret__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>SIRET</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyUserFull.c_siret__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyUserFull', 'c_siret', activation.companyUserFull.c_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyUserFull', 'c_siret')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyUserFull.c_tva__edit === undefined">
                                                        {{activation.companyUserFull.c_tva}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyUserFull', 'c_tva')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyUserFull', 'c_tva', activation.companyUserFull.c_companyID)" *ngIf="activation.companyUserFull.c_tva !== oldScaleFull.activationFull[actI].companyUserFull.c_tva && activation.companyUserFull.c_companyID === oldScaleFull.activationFull[actI].companyUserFull.c_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyUserFull.c_tva__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>N° de TVA Intracommunautaire</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyUserFull.c_tva__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyUserFull', 'c_tva', activation.companyUserFull.c_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyUserFull', 'c_tva')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.companyUserFull.c_siren}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                                <ng-container *ngIf="activation.companyUserFull.c_companyID__edit !== undefined">
                                    <mat-form-field style="width: 25em;">
                                        <mat-label>Compagnie</mat-label>
                                        <input #input
                                               type="text"
                                               placeholder="Choisir..."
                                               matInput
                                               [(ngModel)]="activation.companyUserFull.c_companyID__edit"
                                               [ngModelOptions]="{updateOn: 'change'}"
                                               [matAutocomplete]="auto"
                                               (input)="filterActivationCompanyUserFullOptions(actI, false, input.value)"
                                               (focus)="filterActivationCompanyUserFullOptions(actI, false, input.value)"
                                               required>
                                        <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayActivationCompanyUserFullOption(actI, false)">
                                            <mat-option *ngFor="let opt of activation.companyUserFull.c_companyID__filteredOptions" [value]="opt.companyId">{{opt.socialReason}} ({{opt.companyId}})</mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="!activation.companyUserFull.c_companyID__edit">
                                            Vous devez sélectionner un compagnie pour pouvoir valider.
                                        </mat-error>
                                    </mat-form-field>
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer primaryGreen" (click)="validateActivationCompanyUserFull(actI)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                        <span class="pointer primaryRed" (click)="cancelActivationCompanyUserFull(actI)" title="Annuler"><i class="fas fa-times"></i></span>
                                    </span>
                                </ng-container>
                            </td>
                        </tr>

                        <tr class="tbody-activationPayorCompany">
                            <td colspan="1">Payor company</td>
                            <td colspan="22">
                                <ng-container *ngIf="activation.companyPayorFull.cPayor_companyID__edit === undefined">
                                    <table class="table payorCompanyFull">
                                        <thead>
                                            <tr class="thead-payorCompany">
                                                <th>company ID</th>
                                                <th>unisite code</th>
                                                <th>social reason</th>
                                                <th>address</th>
                                                <th>postal code</th>
                                                <th>city</th>
                                                <th>country</th>
                                                <th>siret</th>
                                                <th>tva</th>
                                                <th>siren</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tbody-payorCompany">
                                                <td>
                                                    {{activation.companyPayorFull.cPayor_companyID}}
                                                    <span [style.whiteSpace]="'nowrap'">
                                                        <span class="pointer steelblue" (click)="editActivationCompanyPayorFull(actI)" title="Échanger"><i class="fas fa-arrow-right-arrow-left"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="duplicateActivationCompanyUserFull(actI, true)" title="Dupliquer"><i class="fas fa-copy"></i>&nbsp;</span>
                                                        <span class="pointer steelblue" (click)="rewindActivationCompanyPayorFull(actI)" *ngIf="activation.companyPayorFull.cPayor_companyID !== oldScaleFull.activationFull[actI].companyPayorFull.cPayor_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_unisiteCode__edit === undefined">
                                                        {{activation.companyPayorFull.cPayor_unisiteCode}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyPayorFull', 'cPayor_unisiteCode')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyPayorFull', 'cPayor_unisiteCode', activation.companyPayorFull.cPayor_companyID)" *ngIf="activation.companyPayorFull.cPayor_unisiteCode !== oldScaleFull.activationFull[actI].companyPayorFull.cPayor_unisiteCode && activation.companyPayorFull.cPayor_companyID === oldScaleFull.activationFull[actI].companyPayorFull.cPayor_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_unisiteCode__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>Code Unisite</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyPayorFull.cPayor_unisiteCode__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyPayorFull', 'cPayor_unisiteCode', activation.companyPayorFull.cPayor_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyPayorFull', 'cPayor_unisiteCode')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.companyPayorFull.cPayor_socialReason}}</td>
                                                <td>{{activation.companyPayorFull.cPayor_address}}</td>
                                                <td>{{activation.companyPayorFull.cPayor_postalCode}}</td>
                                                <td>{{activation.companyPayorFull.cPayor_city}}</td>
                                                <td>{{activation.companyPayorFull.cPayor_country}}</td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_siret__edit === undefined">
                                                        {{activation.companyPayorFull.cPayor_siret}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyPayorFull', 'cPayor_siret')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyPayorFull', 'cPayor_siret', activation.companyPayorFull.cPayor_companyID)" *ngIf="activation.companyPayorFull.cPayor_siret !== oldScaleFull.activationFull[actI].companyPayorFull.cPayor_siret && activation.companyPayorFull.cPayor_companyID === oldScaleFull.activationFull[actI].companyPayorFull.cPayor_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_siret__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>SIRET</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyPayorFull.cPayor_siret__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyPayorFull', 'cPayor_siret', activation.companyPayorFull.cPayor_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyPayorFull', 'cPayor_siret')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_tva__edit === undefined">
                                                        {{activation.companyPayorFull.cPayor_tva}}
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer steelblue" (click)="editActivationSubProp(actI, 'companyPayorFull', 'cPayor_tva')" title="Modifier"><i class="fas fa-edit"></i>&nbsp;</span>
                                                            <span class="pointer steelblue" (click)="rewindActivationSubProp(actI, 'companyPayorFull', 'cPayor_tva', activation.companyPayorFull.cPayor_companyID)" *ngIf="activation.companyPayorFull.cPayor_tva !== oldScaleFull.activationFull[actI].companyPayorFull.cPayor_tva && activation.companyPayorFull.cPayor_companyID === oldScaleFull.activationFull[actI].companyPayorFull.cPayor_companyID" title="Rétablir"><i class="fas fa-history"></i></span>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="activation.companyPayorFull.cPayor_tva__edit !== undefined">
                                                        <mat-form-field>
                                                            <mat-label>N° de TVA Intracommunautaire</mat-label>
                                                            <input matInput [(ngModel)]="activation.companyPayorFull.cPayor_tva__edit">
                                                        </mat-form-field>
                                                        <span [style.whiteSpace]="'nowrap'">
                                                            <span class="pointer primaryGreen" (click)="validateActivationSubProp(actI, 'companyPayorFull', 'cPayor_tva', activation.companyPayorFull.cPayor_companyID)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                                            <span class="pointer primaryRed" (click)="cancelActivationSubProp(actI, 'companyPayorFull', 'cPayor_tva')" title="Annuler"><i class="fas fa-times"></i></span>
                                                        </span>
                                                    </ng-container>
                                                </td>
                                                <td>{{activation.companyPayorFull.cPayor_siren}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ng-container>
                                <ng-container *ngIf="activation.companyPayorFull.cPayor_companyID__edit !== undefined">
                                    <mat-form-field style="width: 25em;">
                                        <mat-label>Compagnie</mat-label>
                                        <input #input
                                               type="text"
                                               placeholder="Choisir..."
                                               matInput
                                               [(ngModel)]="activation.companyPayorFull.cPayor_companyID__edit"
                                               [ngModelOptions]="{updateOn: 'change'}"
                                               [matAutocomplete]="auto"
                                               (input)="filterActivationCompanyUserFullOptions(actI, true, input.value)"
                                               (focus)="filterActivationCompanyUserFullOptions(actI, true, input.value)"
                                               required>
                                        <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayActivationCompanyUserFullOption(actI, true)">
                                            <mat-option *ngFor="let opt of activation.companyPayorFull.cPayor_companyID__filteredOptions" [value]="opt.companyId">{{opt.socialReason}} ({{opt.companyId}})</mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="!activation.companyPayorFull.cPayor_companyID__edit">
                                            Vous devez sélectionner un compagnie pour pouvoir valider.
                                        </mat-error>
                                    </mat-form-field>
                                    <span [style.whiteSpace]="'nowrap'">
                                        <span class="pointer primaryGreen" (click)="validateActivationCompanyPayorFull(actI)" title="Valider"><i class="fas fa-check"></i>&nbsp;</span>
                                        <span class="pointer primaryRed" (click)="cancelActivationCompanyPayorFull(actI)" title="Annuler"><i class="fas fa-times"></i></span>
                                    </span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>

<!-- Modal - Confirmation -->
<div id="confirmationModal" class="modal">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('confirmationModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Confirmation de votre choix </h1>
                <p> Confirmer cette action ? </p>
                <button class="btn btn-secondary" (click)="confirmationModalCB()"> Confirmer </button>
            </div>
        </div>
    </div>
</div>


<!-- Modal - Migrer -->
<div id="migrationModal" class="modal" *ngIf="scaleFull">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('migrationModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Migrer une ou plusieurs activations </h1>
                <div [style.textAlign]="'left'">
                    <span>La migration d'une activation comportant un code de licence n'invalide pas le précédent code.<br/>Cette opération n'est donc à faire qu'après vous être assuré des points suivants:</span>
                    <ul>
                        <li>Ne pas migrer une activation comportant une licence en cours d'une balance d'un client vers une autre balance du même client (il pourrait toujours utiliser le code licence de la première balance)</li>
                        <li>Vérifiez la légitimité de la demande du client et qu'il n'essaie pas d'obtenir une licence supplémentaire sans la payer</li>
                        <li>Assurez-vous que la migration de l'activation soit la seule solution au problème</li>
                    </ul>
                    <span>Si vous avez des doutes, adressez-vous à un développeur.</span>
                </div>
                <form [formGroup]="migration" (ngSubmit)="migrationModalCB()" class="col-6">
                    <mat-form-field class="col-12">
                        <mat-label>Balance vers laquelle migrer</mat-label>
                        <mat-select formControlName="balance" required>
                            <mat-option *ngFor="let opt of availableBalances" [value]="opt.scaleID">{{opt.code}} [{{opt.serialNumber}}] ({{opt.scaleID}})</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-12">
                        <mat-label>Activations à migrer</mat-label>
                        <mat-select formControlName="activations" multiple required>
                            <mat-option *ngFor="let activation of scaleFull.activationFull" [value]="activation.a_activationID">{{activation.a_activationCode}} ({{activation.a_activationID}})</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button class="btn btn-secondary" type="submit"> Migrer </button>
                </form>
            </div>
        </div>
    </div>
</div>



<!-- Modal - Confirmation de migration -->
<div id="confirmCodeModal" class="modal" *ngIf="scaleFull">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('confirmCodeModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Confirmation </h1>
                <p>Un code de confirmation à 4 chiffres a été envoyé aux développeurs et aux membres du support Ixell.</p>
                <p>Pour valider la migration, merci de le recopier ci-dessous.</p>
                <form [formGroup]="migrationConfirm" (ngSubmit)="confirmCodeModalCB()" class="col-6">
                    <mat-form-field class="col-12">
                        <mat-label>Code</mat-label>
                        <input matInput formControlName="code" maxlength="4" required/>
                        <mat-error *ngIf="badCode">Code invalide ou expiré</mat-error>
                    </mat-form-field>
                    <button class="btn btn-secondary" type="submit"> Confirmer </button>
                </form>
            </div>
        </div>
    </div>
</div>



<!-- Modal - Ajout d'une facturation -->
<div id="addBillingModal" class="modal" *ngIf="scaleFull">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('addBillingModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Ajout d'une facturation </h1>
                <form [formGroup]="addBillingForm" class="col-12">
                    <mat-form-field class="col-12">
                        <mat-label>Nombre d'années de licence</mat-label>
                        <input matInput type="number" formControlName="licenseAmount" required min="1" max="5" />
                    </mat-form-field>
                    <mat-form-field class="col-12">
                        <mat-label>Statut</mat-label>
                        <mat-select formControlName="status" required>
                            <mat-option *ngFor="let opt of usableStatuses" [value]="opt.value">{{opt.key}} ({{opt.value}})</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-12">
                        <mat-label>Paiement</mat-label>
                        <mat-select formControlName="isCb" required>
                            <mat-option [value]="true">CB</mat-option>
                            <mat-option [value]="false">Virement/Chèque</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-12">
                        <mat-label>Code Unisite</mat-label>
                        <input matInput formControlName="unisiteCode" required/>
                    </mat-form-field>
                    <mat-form-field class="col-12">
                        <mat-label>Login</mat-label>
                        <input matInput formControlName="login" required/>
                    </mat-form-field>
                    <div class="flex flex-row">
                        <div class="col-6">
                            <h5 class="substitle" [translate]="'scaleform.adressefacturation'"></h5>
                            <hr>
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                <input matInput type="text" formControlName="socialReasonFact" required (input)="shippingCB.checked ? updateSocialReasonLiv() : null">
                                <!-- <mat-error>Saisissez le raison sociale de la société </mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                <input matInput type="text" formControlName="addressFact" required (input)="shippingCB.checked ? updateAddressLiv() : null">
                                <!-- <mat-error>Saisissez l'adresse de la société</mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                <input matInput type="text" formControlName="postalCodeFact" required (input)="shippingCB.checked ? updatePostalCodeLiv() : null">
                                <!-- <mat-error>Saisissez le code postal de la société </mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                <input matInput type="text" formControlName="cityFact" required (input)="shippingCB.checked ? updateCityLiv() : null">
                                <!-- <mat-error>Saisissez la ville de la société </mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                <mat-select formControlName="countryFFact" required (selectionChange)="updateTvaCheck(); shippingCB.checked ? updateCountryFLiv() : null;">
                                    <mat-option *ngFor="let countryF of countries" value="{{countryF.name}}"> {{countryF.txt|translate}} </mat-option>
                                </mat-select>
                                <!-- <mat-error>Saisissez le pays de la société </mat-error> -->
                            </mat-form-field>
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.siret'|translate}}</mat-label>
                                <input matInput type="text" formControlName="siret">
                                <!-- <mat-error>Saisissez le numéro de Siret la société </mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="col-12" *ngIf="tvaCkeck">
                                <mat-label>{{'scaleform.tva'|translate}}</mat-label>
                                <input matInput type="text" formControlName="tva" oninput="this.value = this.value.toUpperCase()" />
                                <mat-error>{{'shoppingcart.invalidTva'|translate}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <h5 class="substitle" [translate]="'shoppingcart.shippingAddress'"> </h5>
                            <hr>
                            <span>
                                <mat-checkbox #shippingCB (click)="copyFacturationData(shippingCB.checked);">
                                    <span [translate]="'shoppingcart.sameShippingAddress'"></span>
                                </mat-checkbox>
                            </span>
                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                                <input matInput type="text" formControlName="socialReason" required>
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                                <input matInput type="text" formControlName="address" required>
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                                <input matInput type="text" formControlName="postalCode" required>
                            </mat-form-field>

                            <mat-form-field class="col-12">
                                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                                <input matInput type="text" formControlName="city" required>
                            </mat-form-field>

                            <mat-form-field class="col-9">
                                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                                <mat-select formControlName="countryF" required>
                                    <mat-option *ngFor="let countryF of countries" value="{{countryF.name}}"> {{countryF.txt|translate}} </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-checkbox formControlName="island" class="col-3">
                                <span [translate]="'shoppingcart.island'"></span>
                            </mat-checkbox>
                        </div>
                    </div>
                    <mat-form-field class="col-12">
                        <mat-label>{{'scaleform.mail'|translate}}</mat-label>
                        <input matInput type="text" formControlName="mail" required>
                        <mat-error>{{'shoppingcart.requiredMail'|translate}}</mat-error>
                    </mat-form-field>
                    <div class="flex flex-row flex-center">
                        <button class="btn btn-secondary" (click)="closeModal('addBillingModal')"> Annuler </button>&nbsp;
                        <button class="btn btn-success" type="submit" (click)="addBillingModalCB(false)"> Ajouter </button>&nbsp;
                        <button class="btn btn-success" type="submit" (click)="addBillingModalCB(true)"> Ajouter sans envoi de mail </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>



<!-- Modal - Confirmation d'ajout de facturation -->
<div id="confirmAddBillingModal" class="modal" *ngIf="scaleFull">
    <div class="modal-content2" [style.height]="'auto'">
        <div class="row">
            <span class="col-12 text-right pointer close" (click)="closeModal('confirmAddBillingModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <div class="col-12 mx-auto text-center flex flex-column flex-center">
                <h1> Confirmation </h1>
                <p>L'ajout d'une facturation, selon le statut cible, peut être irréversible sans l'intervention d'un développeur.</p>
                <p>Êtes-vous bien sûr de vouloir effectuer cette action ?.</p>
                <button class="btn btn-secondary" (click)="confirmAddBillingModalCB()"> Confirmer </button>
            </div>
        </div>
    </div>
</div>
